import { getDocument } from "./auth-service-tools627.js";

var _window;

try {
  _window = window;
} catch (e) {}

function getWindow(element) {
  if (!element) {
    return _window;
  }

  return getDocument(element).defaultView || _window;
}

export { getWindow };